import { render } from "./LoadingArrow.vue?vue&type=template&id=6c7a1252&ts=true"
import script from "./LoadingArrow.vue?vue&type=script&lang=ts"
export * from "./LoadingArrow.vue?vue&type=script&lang=ts"

import "./LoadingArrow.vue?vue&type=style&index=0&id=6c7a1252&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__